import React from "react";
import "./Socials.scss";
// icons
import icon_social__tw from "../../assets/icons/icon-social--tw.svg";
import icon_social__in from "../../assets/icons/icon-social--in.svg";
import icon_social__fb from "../../assets/icons/icon-social--fb.svg";
import icon_social__yt from "../../assets/icons/icon-social--yt.svg";
import icon_social__insta from "../../assets/icons/icon-social--insta.svg";

export default function Socials(props) {
	const socialsList = [
		{
			socialName: "Twitter",
			socialIconUrl: icon_social__tw,
			socialLink: "https://twitter.com/kodjoenglish",
		},
		{
			socialName: "LinkedIn",
			socialIconUrl: icon_social__in,
			socialLink: "https://www.linkedin.com/in/kodjohounnake/",
		},
		{
			socialName: "Facebook",
			socialIconUrl: icon_social__fb,
			socialLink: "https://www.facebook.com/KodjoEnglish/",
		},
		{
			socialName: "Youtube",
			socialIconUrl: icon_social__yt,
			socialLink: "https://www.youtube.com/channel/UCN5Ik8tlKQI4fJV4BU2SeVQ",
		},
		{
			socialName: "Instagram",
			socialIconUrl: icon_social__insta,
			socialLink: "https://www.instagram.com/kodjoenglish/",
		},
	];

	const socialItems = socialsList.map((item, intex) => {
		return (
			<a className="socials__item d-flex align-items-center justify-content-center" href={`${item.socialLink}`} key={intex} target='_blank' rel='noopener noreferrer'>
				<img src={item.socialIconUrl} alt={`${item.socialName} icon`} />
			</a>
		);
	});

	return <div className={`socials d-flex align-items-center justify-content-center ${props.class}`}>{socialItems} </div>;
}
